import tripEvents from './../../config/events.constant';
import templateValidationDialog from './../../templates/checkoutValidationDialog.html';
import tripStatuses from '../../trip-statuses';
import carbonPurchase from '../../carbon-purchase-options';

export default function TripCheckoutController(
    $rootScope,
    $scope,
    $stateParams,
    $state,
    $uibModal,
    tripId,
    tripDetails,
    tripFactory,
    tripAPI,
    tripData,
    tripValidation,
    userService,
    flightsUtils,
    tripUtils,
    flightFareService,
    railsUtils,
    tripCheckoutModel,
    tripDetailsService,
    tripItemRailRecommendationService,
    railAmendmentService,
    tripTravellerAllocationService,
    selectedSeatsService,
    tripCheckoutService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isNoteForBillbackHotelsVisible,
        isPendingConfirmationDescriptionVisible,
        pageTitle: getCheckoutPageTitle(),
        updateTravellersDetails,
    });

    function $onInit() {
        vm.isAmendmentMode = railAmendmentService.isAmendmentMode();
        if ([tripStatuses.QUOTE, tripStatuses.HELD].includes(tripDetails.Status) && !tripDetails.Locked) {
            tripCheckoutService.checkTravellerDetailsChanges(tripDetails.Travelers.Adult)
                .then(updateTravellersDetails);
        }
        vm.isSeatMapAvailable = userService.isSeatMapServiceAvailable();

        $scope.$on(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS_FINISHED, initializeSelectedSeats);
        initializeSelectedSeats();

        $scope.$on(tripEvents.TRIP_DETAILS_UPDATE, updateDetails);
        $scope.$on(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS, updateDetails);
    }

    function updateDetails() {
        tripFactory.tripDetails(tripId)
            .then(({Flights, Travelers}) => {
                $scope.tripDetails.Flights = Flights;
                $scope.tripDetails.Travelers = Travelers;
                updatePrices($scope.tripData.ApprovalSettings, $scope.tripData);
                $rootScope.$broadcast(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS_FINISHED);
            });
    }

    function updateTravellersDetails() {
        tripFactory.getTripCheckoutData(tripId)
            .then((checkoutData) => {
                tripDetails.Travelers = checkoutData.Travelers;
                $scope.tripData = checkoutData;
                $scope.$broadcast(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE);
            });
    }

    function isPendingConfirmationDescriptionVisible() {
        return tripDetails.Status === tripStatuses.PENDING_CONFIRMATION
            && tripDetails.IsOfflineTrip;
    }

    function isNoteForBillbackHotelsVisible() {
        return tripDetailsService.doesTripContainBillbackRoom(tripDetails)
            && tripDetailsService.isTripPaymentTypeInvoice(tripCheckoutModel);
    }

    function getCheckoutPageTitle() {
        return $stateParams.rebook ? 'Checkout - Ticket Amendment' : 'Checkout';
    }

    const approvalSettings = tripData.ApprovalSettings;

    if (!tripValidation.isValid) {
        const modalInstance = $uibModal.open(
            {
                animation: true,
                template: templateValidationDialog,
                controller: [
                    '$scope', '$uibModalInstance', function(scope, $uibModalInstance) {
                        scope.ok = function() {
                            $uibModalInstance.close();
                        };
                        scope.tripValidation = tripValidation;
                    },
                ],
                size: 'lg',
            }
        );

        if (modalInstance) {
            modalInstance.result.then(
                function() {
                    $state.go('main.trip.list');
                },
                function() {
                    $state.go('main.trip.list');
                }
            );
        }
    }


    $scope.tripDetails = tripDetails;
    $scope.tripData = tripData;

    $scope.actionData = {}; //Used as shared variable between `tripCheckoutPaymentCodesController` and `tripCheckoutButtonsController`

    updatePrices(tripData.ApprovalSettings, tripData);

    $scope.flightFareService = flightFareService;
    $scope.tripHeld = false;
    $scope.dataTravelers = $scope.tripDetails.Travelers;
    $scope.countDays = tripUtils.countDays;
    $scope.findFlightStop = flightsUtils.findFlightStop;
    $scope.findDestination = flightsUtils.findDestination;
    $scope.collectAllCities = flightsUtils.collectAllCities;
    $scope.flightType = flightsUtils.flightType;
    $scope.userCulture = userService.getCulture && userService.getCulture();
    $scope.isUSRegion = userService.isUSRegion && userService.isUSRegion();
    $scope.carbonPurchaseVisible = tripData.CarbonPurchase !== carbonPurchase.NotAllowed && tripData.Flights.length > 0;
    $scope.singleApprover = tripData.ApprovalSettings && tripData.ApprovalSettings.SingleSelfApprovingTrip;
    $scope.seats = {};

    if (approvalSettings) {
        $scope.showApproverMessage = approvalSettings.SingleApprovingTrip
            && approvalSettings.IsApprovalRequired;
    }

    function initializeSelectedSeats() {
        const oldSelectedSeats = $scope.seats.selectedSeats;
        const selectedSeats = tripTravellerAllocationService.prepareSeats($scope.tripDetails);
        const allSelectedSeats = tripTravellerAllocationService.addNonSelectedSeats(selectedSeats, $scope.tripDetails);
        if (!oldSelectedSeats) {
            $scope.seats.selectedSeats = allSelectedSeats;
        } else {
            $scope.seats.selectedSeats = tripTravellerAllocationService.restoreSelectedFfn(allSelectedSeats, oldSelectedSeats);
        }
    }

    $scope.checkSameAirports = function(flightSegments, segmentIndex, departureBlock) {
        const segmentsData = [];

        angular.forEach(flightSegments, function(segment, index) {
            const flightIndex = index ? segment.Flights.length - 1 : 0;
            segmentsData.push(segment.Flights[flightIndex]);
        });

        return flightsUtils.checkSameAirports(segmentsData, segmentIndex, departureBlock);
    };

    $scope.generateRulesParameters = tripUtils.generateRulesParameters;

    $scope.submitTried = false;

    $scope.invoiceOnly = {
        value: false,
    };

    $scope.lastFlight = flightsUtils.lastFlight;

    $scope.wasConfirmed = $scope.tripDetails.WasConfirmed;

    $scope.$on(tripEvents.TRIP_CHECKOUT_SUBMIT_TRY, function() {
        $scope.submitTried = true;
    });

    $scope.hideCardFee = !$scope.tripDetails.WasConfirmed
        || tripDetailsService.isTripPaymentTypeInvoice(tripCheckoutModel);

    $scope.updateCardFeeVisibility = function(hide) {
        $scope.hideCardFee = hide;
    };

    $scope.$on(tripEvents.TRIP_REFRESH_ITINERARY, function(event, arg) {

        tripFactory.getTripCheckoutData(tripId).then(function(checkoutData) {
            $scope.tripDetails = arg;

            updatePrices(checkoutData.ApprovalSettings, checkoutData);

            $scope.tripData = checkoutData;
            initializeSelectedSeats();
            $scope.$broadcast(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE);
        });
    });

    $scope.$on(tripEvents.TRIP_START_BOOK, function() {
        $scope.isBook = true;
    });

    $scope.$on(tripEvents.TRIP_START_HOLD, function() {
        $scope.isHold = true;
    });

    $scope.$on(tripEvents.TRIP_FINISH_HOLD, function() {
        $scope.isBook = false;
        $scope.isHold = false;
        $scope.tripHeld = true;
    });

    $scope.$on(tripEvents.TRIP_FINISH_BOOK, function() {
        $scope.isBook = false;
        $scope.isHold = false;
    });

    $scope.$on(tripEvents.TRIP_CANCEL_CHECKOUT_PROCESS, function() {
        $scope.isBook = false;
        $scope.isHold = false;
    });

    $scope.$on(tripEvents.TRIP_UPDATE_COSTS, function(event, args) {
        const luggageData = tripFactory.getLuggageData($scope.tripData.LuggageOptions);
        const cardType = args && args.cardType || $scope.tripData.SelectedCreditCard && $scope.tripData.SelectedCreditCard.CreditCardType;
        const isInvoice = args && (typeof args.isInvoice === 'boolean') ? args.isInvoice : $scope.tripData.IsPaymentTypeInvoice;
        const purchaseCarbon = args && (typeof args.purchaseCarbon === 'boolean') ? args.purchaseCarbon : null;

        const {newRailRecommendationId: recommendationId} = $stateParams;
        const params = {
            tripId,
            cardType,
            isInvoice,
            luggageData,
            recommendationId,
            purchaseCarbon,
        };
        tripAPI.updatedTripCosts(params)
            .then(({ApprovalSettings, TripPrices, IsCarbonPurchased}) => updatePrices(ApprovalSettings, TripPrices, IsCarbonPurchased));
    });

    function updatePrices(approval, tripPrices, isCarbonPurchased) {
        const {
            Flights: flights,
            Hotels: hotels,
            Cars: cars,
            Rails: rails,
            Buses: buses,
            Taxis: taxis,
            Ferries: ferries,
            CreditCardTypes: creditCardTypes,
            DiscountedLuggages: discountedLuggages,
            Prices: prices,
        } = tripPrices;

        Object.assign($scope.tripData, {
            Flights: tripPrices.Flights,
        });

        $scope.tripDetails.Flights = tripFactory.updateItemPrices($scope.tripDetails.Flights, flights);
        $scope.tripDetails.Hotels = tripFactory.updateItemPrices($scope.tripDetails.Hotels, hotels);
        $scope.tripDetails.Cars = tripFactory.updateItemPrices($scope.tripDetails.Cars, cars);
        $scope.tripDetails.Buses = tripFactory.updateItemPrices($scope.tripDetails.Buses, buses);
        $scope.tripDetails.Taxis = tripFactory.updateItemPrices($scope.tripDetails.Taxis, taxis);
        $scope.tripDetails.Ferries = tripFactory.updateItemPrices($scope.tripDetails.Ferries, ferries);
        $scope.tripData.Rails = rails;

        $rootScope.$broadcast(tripEvents.UPDATE_CREDIT_CARDS, creditCardTypes);
        $rootScope.$emit(tripEvents.UPDATE_DISCOUNT_LUGGAGE, discountedLuggages);
        $scope.tripData.Prices = angular.copy(prices);
        $scope.tripData.ApprovalSettings = angular.copy(approval);
        if (isCarbonPurchased === true || isCarbonPurchased === false) {
            $scope.tripData.IsCarbonPurchased = isCarbonPurchased;
        }

        $scope.$broadcast(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE);
    }

    $scope.isTravelCardPresent = function(journey, rail) {
        return journey.Direction === 0 && rail.AddonName !== '';
    };
    $scope.collectAllRailJourneyCities = function(rail) {
        $scope.allStationCities = [];
        $scope.railSeatCount = '';
        if (rail) {
            $scope.allStationCities = tripItemRailRecommendationService.getAllStations(rail);
            $scope.railSeatCount = Number(rail.Adults) + Number(rail.Children);
        }
        return $scope.allStationCities;
    };

    $scope.$on(tripEvents.SET_STATIC_APPROVERS, function() {
        for (let i = 0; i < $scope.tripData.PaymentCodes.length; i++) {
            tripCheckoutService.getStaticApprovers($scope.tripData.PaymentCodes[i].Id).then((response) => {
                    processApproversResponse(response, $scope.tripData.PaymentCodes[i].Id);
            }
            );
        }
    });


    function processApproversResponse(response, code) {
        if (Object.keys(response.data).length > 0) {
            const results = ({
                data: response.data,
                paymentCodeId: code,
            });
            $rootScope.$broadcast(tripEvents.PROCESS_STATIC_APPROVERS, results);
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-controller.js